import { render, staticRenderFns } from "./properties-block-list-category.vue?vue&type=template&id=aa838560&scoped=true"
import script from "./properties-block-list-category.vue?vue&type=script&lang=js"
export * from "./properties-block-list-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa838560",
  null
  
)

export default component.exports